"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onTrash = exports.onMarkAsSpam = exports.onChangeSticky = exports.onChangeCloseTopicForReplies = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _logger = require("@insided/shared/services/logger");

var _topicService = require("@insided/shared/services/topicService");

var onMarkAsSpam = function onMarkAsSpam(e, showMarkAsSpamModal) {
  e.preventDefault();
  showMarkAsSpamModal(true);
};

exports.onMarkAsSpam = onMarkAsSpam;

var onTrash = function onTrash(e, showTrashModal) {
  e.preventDefault();
  showTrashModal(true);
};

exports.onTrash = onTrash;

var onChangeSticky = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e, privateId, isSticky, contentType, onShowAlert) {
    var newSticky;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            newSticky = !isSticky;
            _context.prev = 2;
            _context.next = 5;
            return (0, _topicService.toggleSticky)(contentType, privateId, newSticky);

          case 5:
            onShowAlert('success', newSticky ? 'frontend_moderation.topic_marked_as_sticky' : 'frontend_moderation.topic_unmarked_as_sticky');
            window.location.reload();
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

            _logger.logger.error(_context.t0, {
              component: 'topicService',
              action: 'toggleSticky'
            });

            onShowAlert('error', newSticky ? 'frontend_moderation.error_marking_topic_as_sticky' : 'frontend_moderation.error_unmarking_topic_as_sticky');

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  }));

  return function onChangeSticky(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

exports.onChangeSticky = onChangeSticky;

var onChangeCloseTopicForReplies = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e, privateId, isClosed, contentType, onShowAlert) {
    var newClosed;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            newClosed = !isClosed;
            _context2.prev = 2;
            _context2.next = 5;
            return (0, _topicService.toggleClosed)(contentType, privateId, newClosed);

          case 5:
            onShowAlert('success', newClosed ? 'frontend_moderation.topic_closed_for_further_replies' : 'frontend_moderation.topic_reopened_for_further_replies');
            window.location.reload();
            _context2.next = 13;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);

            _logger.logger.error(_context2.t0, {
              component: 'topicService',
              action: 'toggleClosed'
            });

            onShowAlert('error', newClosed ? 'frontend_moderation.error_closing_topic_for_replies' : 'frontend_moderation.error_reopening_topic_for_replies');

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 9]]);
  }));

  return function onChangeCloseTopicForReplies(_x6, _x7, _x8, _x9, _x10) {
    return _ref2.apply(this, arguments);
  };
}();

exports.onChangeCloseTopicForReplies = onChangeCloseTopicForReplies;